<template>
  <div class="cart-overview">
    <div v-if="cartItems.length > 0" class="cart-product-list">
      <div class="cart-product" v-for="(item,index) in cartItems" :key="index">
       
        <div class="cart-product__body">
          <img :src="item.thumbnail?item.thumbnail:'@/assets/common/images/wqa/3.png'" @error="onImageError" alt="product thumbnail" class="cart-product__image" />
          <div class="cart-product__info">
            <div class="cart-product__left_side_content">
              <RouterLink :to="'/product/'+(item.detail?.url_key?item.detail?.url_key:item.url_key)" style="cursor:pointer;text-decoration: none;color:unset;">
                <span class="cart-product__title">{{ item.detail_name }}</span>
              </RouterLink>
              <div class="cart-product__metadata">
                <span><strong>CV:</strong>&nbsp;{{ item.pv }}</span>
                <span>|</span>
                <span>{{ item.uom }}</span>
              </div>
            </div>
            <div class="cart-product__right_side_content">
              <button v-if="editMode" @click="removeItem(item)" class="cart-product__remove-btn">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="cart-product__footer">
          <div class="cart-product__quantity-selector">
            <label>Quantity:</label>
            <select v-if="editMode" :value="(item.quantity?item.quantity:item.detail.quantity)" @change="updateQuantity(item, $event.target.value)">
              <option v-for="num in 100" :key="num" :value="num">{{ num }}</option>
              <option v-if="(item.quantity?item.quantity:item.detail.quantity)> 10" :value="(item.quantity?item.quantity:item.detail.quantity)">{{ item.quantity?item.quantity:item.detail.quantity }}</option>
            </select>
            <span v-else style="padding:0 10px;">{{ item.quantity?item.quantity:item.detail.quantity }}</span>
          </div>
          <div class="cart-product__pricing">
            <!-- <span class="price-original" v-if="item.detail?.cv">₹{{ parseFloat(item.price * (item.quantity?item.quantity:item.detail.quantity)).toFixed(0) }}</span> -->
            <!-- <span class="price-current" v-if="isCheckoutRoute">DP ₹{{parseInt(item.detail?.final_total) }}</span> -->
            <span class="text-bold" v-if="item.detail?.cv">Wholesale : 
              <span class="price-original">
                ₹{{parseFloat(getUpdatedPrice2(item)).toFixed(2) }}
              </span>
              <span class="price-current" v-if="item.detail?.cv">₹{{ parseFloat(item.base_price).toFixed(0) }}</span>
            </span>
            <span class="price-current" v-else>Wholesale : ₹{{parseFloat(getUpdatedPrice2(item)).toFixed(2) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="cart-empty-state">
      <img src="~@/assets/common/images/icons/empty_cart.png" alt="Empty Cart" />
      <p>Your cart is empty</p>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/stores/cart";
import { computed,ref, watch } from "vue";
import { useRoute } from "vue-router";
export default {
  name: "ShoppingCartItems",
  props:{
    editMode:{
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const route = useRoute();

    // Check if the route name is 'checkout'
    const isCheckoutRoute = computed(() =>route.fullPath.includes('checkout'));
    // const isCartRoute = computed(() =>route.fullPath.includes('cart'));
  
    const cartStore = useCartStore();
    let cartItems = computed(() => cartStore.cartItems);
    const deleting_id = ref("");

    const removeItem = async (product) => {
      const productId = product.product_id;
      deleting_id.value = productId;
      await cartStore.removeFromCart(productId);
      deleting_id.value = "";
    };

    const updateQuantity = async (product, quantity) => {
      await cartStore.updateQuantity(product.product_id, quantity);
    };
    function onImageError(event) {
      event.target.src = require('@/assets/common/images/wqa/3.jpg');
    }
    // onMounted(()=>{
    //   if(!isCartRoute.value){
    //     alert('1')
    //     cartStore.fetchCart(false,true);
    //   } 
    // })
    watch(
      () => route.fullPath, 
      (newVal) => {
        if (!newVal.includes('cart')) {
          cartStore.fetchCart(true,false);
          // cartStore.fetchCart(false,true);
        }
      }
    );
    // function getUpdatedPrice2(item) {
    //     let finalPrice=null;
    //     const itemsNew = cartItems.value.map((p)=>{
    //       if(p.detail?.id == item.detail?.id){
    //         return item
    //       }
    //       return p
    //     });
    //     const newpointsProducts = itemsNew.reduce((total, item) => {
    //       return item.detail?.cv ? total + item.quantity : total;
    //     }, 0)
    //     const originalPrice = parseFloat(item.price) * item.quantity;
        
        
    //     if (item.detail?.cv && (item.detail?.cp_price ? item.detail?.cp_price : item?.cp_price)) {
    //       const feePerItem = 100 / newpointsProducts;
    //       const discountedFee = feePerItem * (1 - (item?.detail?.discount_percent || 0) / 100);
    //       item.updated_base_price=discountedFee;
    //       // const used_points=Number(item.detail?.cp_price ? item.detail?.cp_price: item?.cp_price) * Number(item.quantity);
    //       item.base_price=discountedFee;
    //       if (parseInt(item.detail?.discount_percent)) {
    //         // alert(item.detail?.discount_percent)
    //         finalPrice= item.detail.price_after_discount * Number(item.quantity);
    //         // return finalPrice;
    //       }
    //       finalPrice= discountedFee * item.quantity;
    //       // return finalPrice;
    //     }else if (parseInt(item.detail?.discount_percent)) {
    //       // alert(item.detail?.discount_percent)
    //       if(item.detail?.discount_amount!=0){
    //               finalPrice= (Number(item.detail.price_after_discount) * Number(item.quantity))-Number(item.detail?.discount_amount);
    //             }else{
    //               finalPrice= item.detail.price_after_discount * Number(item.quantity);
    //             }
    //       return finalPrice;
    //     }
    //     if(finalPrice==null){
    //       finalPrice= originalPrice;
    //     }
    //     // if(finalPrice!=originalPrice){
    //     //   updateItem(item,finalPrice);
    //     // }
    //     // console.log(item,'from udpatedPrice')
    //     return finalPrice;
    //     // return originalPrice * Number(item.quantity);

    //   }
    function getUpdatedPrice2(item) {
        let finalPrice=null;
        // const itemsNew = cartItems.value.map((p)=>{
        //   if(p.detail?.id == item.detail?.id){
        //     return item
        //   }
        //   return p
        // });
        // const newpointsProducts = itemsNew.reduce((total, item) => {
        //   return item.detail?.cv ? total + item.quantity : total;
        // }, 0)
    
        const originalPrice = parseFloat(item.detail?.base_price) * item.quantity;
        // const originalPrice = parseFloat(item.detail?.price) * item.quantity;
        // alert(item.discount_percent)
        
        if(isCheckoutRoute.value){
          if ((item.detail.cv || (item.detail?.additional?.is_cv && item.detail?.additional?.isFreeItem) || false) && (item.detail?.cp_price ? item.detail?.cp_price : item?.cp_price)) {
            // const feePerItem = 100 / newpointsProducts;
            // const discountedFee = feePerItem * (1 - (item?.detail?.discount_percent || 0) / 100);
            const discountedFee = 1;
            item.updated_base_price=discountedFee;
            // const used_points=Number(item.detail?.cp_price ? item.detail?.cp_price: item?.cp_price) * Number(item.quantity);
            item.base_price=discountedFee;
            if (parseInt(item.detail?.discount_percent)) {
              // alert(item.detail?.discount_percent)
              finalPrice= item.detail.price_after_discount * Number(item.quantity);
              // return finalPrice;
            }
            finalPrice= discountedFee ;
            // finalPrice= discountedFee * item.quantity;
            // return finalPrice;
          }
        }
        // else{
          if (parseInt(item.detail?.discount_percent)) {  
            // alert(item.detail?.discount_percent)
            // console.log(item.detail,'indic');
            finalPrice= item.detail.price_after_discount * Number(item.quantity);
            if(item.cv){
              finalPrice=1;
            }
            // alert(finalPrice)
            // finalPrice= originalPrice - Number(item.detail?.discount_amount);
            return finalPrice;
          }
        // }
        if(finalPrice==null){
          finalPrice= originalPrice;
        }
        // if(finalPrice!=originalPrice){
        //   updateItem(item,finalPrice);
        // }
        // console.log(item,'from udpatedPrice')
        return finalPrice;
        // return originalPrice * Number(item.quantity);

      }
    return {
      cartItems,
      removeItem,
      isCheckoutRoute,
      updateQuantity,
      deleting_id,
      getUpdatedPrice2,
      onImageError
    };
  },
};
</script>

<style scoped>

.cart-product-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.cart-product {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 19, 37, 0.08);
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
}

.cart-product__body {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 5px 0;
}

.cart-product__image {
  width: 90px;
  height: 90px;
  object-fit: cover;
}

.cart-product__info {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
}

.cart-product__title {
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 200px;
  text-align: left;
}

.cart-product__metadata {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cart-product__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(0, 19, 37, 0.08);
  /* padding-top: 10px; */
  padding: 10px 5px 0 5px;
}

.cart-product__quantity-selector select {
  margin-left: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.cart-product__pricing {
  display: flex;
  align-items: center;
  gap: 5px;
}

.price-original {
  text-decoration: line-through;
  color: #7692ad;
}

.price-current {
  font-weight: bold;
}

.cart-product__remove-btn {
  background: none;
  border: none;
  /* color: red; */
  cursor: pointer;
}

.cart-empty-state {
  text-align: center;
}

.cart-empty-state img {
  width: 100px;
  margin-bottom: 10px;
}
</style>
